import { Button } from '@foam/buoy/src/components/Button/Button';
import { useRouter } from 'next/router';
import { MockMetrics } from '~/components/CreatorChannelMetrics/MockMetrics';
import { SOCIAL_PLATFORMS } from '~/constants';

interface Props {
  platform: SOCIAL_PLATFORMS;
  isCreator?: boolean;
  hasNoRecentContent?: boolean;
  showConnectMessage?: boolean;
  slug?: string;
}

export const MetricsEmptyState: React.FC<Props> = ({
  platform,
  isCreator = false,
  hasNoRecentContent = false,
  showConnectMessage = false,
  slug,
}) => {
  const router = useRouter();

  const navigateToConnections = () => {
    if (!slug) return;
    router.push(`/t/${slug}/platform-connections`);
  };

  const getMessage = () => {
    if (isCreator && hasNoRecentContent) {
      return 'Metrics are not available because no recent content has been posted.';
    }
    if (showConnectMessage) {
      return 'Add real-time, auto-updating metrics by having the Talent connect their social accounts—no more requesting screenshots.';
    }
    return 'Channel metrics for this Talent are currently unavailable. Please try again later.';
  };

  return (
    <div className="relative overflow-hidden rounded-12">
      <div className="pointer-events-none select-none opacity-30">
        <MockMetrics platform={platform} />
      </div>
      <div className="absolute inset-0 z-20 flex items-center justify-center p-4">
        <div className="mx-auto flex max-w-[708px] flex-col justify-center gap-6 text-center">
          <h2
            className="text-20 font-500 leading-[25px]"
            style={{
              textShadow: '0 0 10px white, 0 0 20px white, 0 0 30px white',
            }}
          >
            {getMessage()}
          </h2>
          {showConnectMessage && slug ? (
            <div className="flex justify-center">
              <Button size="lg" onClick={navigateToConnections}>
                Connect
              </Button>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};
